import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Icon, Loader } from "semantic-ui-react";
import { completeCurrentInspection, downloadWorkInspectionDocument, getCurrentWorkInspectionDetailInfo, getCurrentWorkInspectionDocuments, getCurrentWorkInspectionInfo, updateCurrentInspectionDetails } from "../../api/BorrowerApi";
import { completeMockCurrentInspection, downloadMockWorkInspectionDocument, getMockCurrentWorkInspectionInfo, updateMockCurrentInspectionDetails, updateMockInspectionDetailList } from "../../api/mock/MockBorrowerApi";
import { convertToDateString, deepCopy, handleErrorResponse } from "../../Helpers";
import { BorrowerConstants } from "../constants/BorrowerConstants";
import { IErrorResponse, IProxyUser } from "../interfaces/Global";
import BCDashboard from "../ui/BCDashboard";
import BCFormInput from "../ui/BCFormInput";
import BCMessage from "../ui/BCMessage";
import BCTabMenuBar from "../ui/BCTabMenuBar";
import BCUploadBox from "../ui/BCUploadBox";
import BWWorkInspectionInteriorTable from "./BWWorkInspectionInteriorTable";
import "../../styles/borrower/inspection.scss";
import { GlobalConstants } from "../constants/GlobalConstants";
import BCButton from "../ui/BCButton";
import { FeatureFlags } from "../constants/LocalServerConstants";
import BCConfirmationModal from "../ui/BCConfirmationModal";

interface IBWCurrentWorkInspection {
  isGreaterThanMobile: boolean;
  isGreaterThanTablet: boolean;
  isSidebar: boolean;
  isMessage: boolean;
  setIsMessage: React.Dispatch<React.SetStateAction<boolean>>;
  errorResponse: IErrorResponse | undefined; 
  setErrorResponse: React.Dispatch<React.SetStateAction<IErrorResponse | undefined>>; 
  projectId: string,
  user: any; 
  proxyUser: IProxyUser | undefined;
}

interface IInspectionDetail {
  budgetAmount: number,
  category: string,
  comment: string | null,
  cumulativePercentComplete: number | null | undefined,
  editableOnGridId: number,
  id: string,
  lineNumber: number,
  loanBudgetSubCategory: string | null | undefined,
  lockVersion: number,
  nwccinspectionId: string,
  previousCumulativePercent: number | null | undefined,
}

const BWCurrentWorkInspection = ({
  isGreaterThanMobile,
  isGreaterThanTablet,
  isSidebar,
  isMessage,
  setIsMessage,
  errorResponse,
  setErrorResponse,
  projectId,
  user,
  proxyUser,
}  : IBWCurrentWorkInspection) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [isFirstLoad, setIsFirstLoad] = useState(true as boolean);
  const [isInteriorCardLoading, setIsInteriorCardLoading] = useState(false as boolean);
  const [activeTab, setActiveTab] = useState(BorrowerConstants.currentInspectionInteriorCardTabs.Details.name.toLocaleUpperCase());
  const [currentInspectionInfo, setCurrentInspectionInfo] = useState({} as any);
  const [currentInspectionDetails, setCurrentInspectionDetails] = useState([] as IInspectionDetail[]);
  const [currentInspectionDocumentss, setCurrentInspectionDocumentss] = useState([] as any[]);
  const [updatedInspection, setUpdatedInspection] = useState({} as any);
  const [updatedInspectionDetailList, setUpdatedInspectionDetailList] = useState([] as any);
  const [isCompleteInspectModalOpen, setIsCompleteInspectionModalOpen] = useState(false as boolean);
  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const handleBackToCurrentInspections = useCallback(() => {
    history.push("/currentinspections");
  }, [history]);

  const handleActiveTabAsync = async (newActiveTab) => {
    setIsInteriorCardLoading(true);
    setActiveTab(newActiveTab);
    setIsInteriorCardLoading(false);
  };

  const keyOfInspectionDetail = (name: keyof IInspectionDetail) : string => name;
  const handleDateChangeInputField = (date, field) => {
    const handleDisplayDate = (date) => {
      let displayDate = date;
      if (Object.keys(updatedInspection).includes(field) && updatedInspection[field]) {
        displayDate = updatedInspection[field];
      }

      return convertToDateString(convertToDateString(displayDate), "calendar");
    };

    const handleDateChange = async (value) => {
      updatedInspection[field] = value + "T00:00:00";
      setUpdatedInspection({...updatedInspection});
    };

    return (
      <BCFormInput 
        inputCalendarClass="current-inspections-calendar"
        labelClass="gmr-background-label"
        value={handleDisplayDate(date)}
        type="calendar"
        obj={updatedInspection}
        handleFormChange={(value) =>  handleDateChange(value)}
        required
      />
    );
  };
    
  const EditDetailColumn = (isEditField, detail, value, field, fieldType) => {
    const selectedDetail = updatedInspectionDetailList.find(x => x.id === detail.id);
    const handleSwitchToEditDMode = () => {
      detail[isEditField] = true;
      const turnOffEditModeDetails = currentInspectionDetails.map(x => {
        x[isEditField] = x.id !== detail.id ? false : true;
        return x;
      });

      setCurrentInspectionDetails([...turnOffEditModeDetails]);
    };

    const handleDisplayValue = (field) => {
      if (selectedDetail && Object.keys(selectedDetail).includes(field)) {
        return selectedDetail[field];
      }

      return value;
    };

    const handleDetailInfoChange = (value, field, detail) => {
      if (selectedDetail) {
        selectedDetail[field] = value;
      }
      else {
        const updatedDetail = {
          id: detail.id,
          nwccinspectionId: detail.nwccinspectionId
        };

        updatedDetail[field] = value;
        updatedInspectionDetailList.push({...updatedDetail});
      }
      
      setUpdatedInspectionDetailList([...updatedInspectionDetailList]);
    };

    return (
      <React.Fragment>
      {detail && detail[isEditField] ? <BCFormInput
          labelClass="gmr-background-label"
          type="input"
          value={handleDisplayValue(field)}
          field={field}
          fieldType={fieldType}
          handleFormChange={(value, field) => handleDetailInfoChange(value, field, detail)}
        /> :
        <div>
          <Icon name="edit" onClick={() => handleSwitchToEditDMode()} />
          <span className="inpsection-detail-edit-column">{handleDisplayValue(field)}</span>
        </div>
      }
      </React.Fragment>
    );
  };
    
  const handleInspectionDetails = (currentInspectionDetails) => {
    const result = [] as any[];
    currentInspectionDetails.forEach(detail => {
      const resultItem = {
        editPercentComplete : detail.editPercentComplete,
        editComment : detail.editComment
      };

      Object.entries(detail).forEach(([key, value]) => {
        if (key === keyOfInspectionDetail("loanBudgetSubCategory")) {
          resultItem[key] = detail[key] ? detail[key].split(" - ")[1] : "";
        }
        else if (key === keyOfInspectionDetail("cumulativePercentComplete")) {
          resultItem[key] = EditDetailColumn("editPercentComplete", detail, value, "cumulativePercentComplete", GlobalConstants.InputTypes.PERCENTAGE);
        }
        else if (key === keyOfInspectionDetail("comment")) {
          resultItem[key] = EditDetailColumn("editComment", detail, value, "comment", GlobalConstants.InputTypes.STRING);
        }
        else {
          resultItem[key] = value;
        }
      });

      result.push(resultItem);
    });

    return result;
  };

  const WorkInspectionButtonGroup = () => {
    const updatedCurrentInspectionDetailsAsync = async () => {
      setIsLoading(true);
      try {
        const response = FeatureFlags.IS_MOCK ? await updateMockCurrentInspectionDetails(currentInspectionInfo.id) : await updateCurrentInspectionDetails(currentInspectionInfo.id, proxyUser && proxyUser.id);
        if (response && response.ok) {
          setIsMessage(false);
          const updateSuccess = await response.json();
          return updateSuccess;
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }

      setIsLoading(false);
    };

    return (
      <div className="button-group-wrapper">
        <BCButton labelPosition="left" iconName="save" handleOnClick={() => updatedCurrentInspectionDetailsAsync()}>Save</BCButton>
        <BCButton labelPosition="left" iconName="save" handleOnClick={() => {updatedCurrentInspectionDetailsAsync(); handleBackToCurrentInspections();}}>Save and Close</BCButton>
        <BCButton labelPosition="left" iconName="check circle outline" handleOnClick={() => setIsCompleteInspectionModalOpen(true)} >Mark as Complete</BCButton>
        <BCButton labelPosition="left" iconName="close" handleOnClick={() => handleBackToCurrentInspections()} >Close</BCButton>
      </div>
    );
  };

  const SaveInpsectionDetailsButton = () => {
    const updateInspectionDetailsAsync = async (detailList) => { // TODO: ask Salam, can update but no response back
      setIsLoading(true);
      try {
        const response = FeatureFlags.IS_MOCK ? await updateMockInspectionDetailList(detailList) : await updateCurrentInspectionDetails(detailList, proxyUser && proxyUser.id);
        if (response && response.ok) {
          setIsMessage(false);
          const updateSuccess = await response.json();
          return updateSuccess;
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }

      setIsLoading(false);
    };

    return (
      <BCButton labelPosition="left" iconName="save" handleOnClick={() => updateInspectionDetailsAsync(updatedInspectionDetailList)}>Save</BCButton>
    );
  };

  const CancelInpsectionDetailsEditButton = () => {
    const cancelInspectionDetailsChanges = () => {
      currentInspectionDetails.map(x => {
        x["editPercentComplete"] = false;
        x["editComment"] = false;
        return x;
      });

      setCurrentInspectionDetails([...currentInspectionDetails]);
      setUpdatedInspectionDetailList([]);
    };

    return (
      <BCButton labelPosition="left" iconName="close" handleOnClick={() => cancelInspectionDetailsChanges()}>Cancel</BCButton>
    );
  };

  const LoaderLayout = [
    [
      {
        size: 16,
        content: <Loader active inline="centered" size={"big"} />
      }
    ]
  ];
    
  const InspectionDetailsLayout = [
    [
      {
        title: "Details",
        size: 16,
        content: <BWWorkInspectionInteriorTable 
          additionalMenuBarLeftChildren={[<SaveInpsectionDetailsButton />, <CancelInpsectionDetailsEditButton />]}
          dataRules={[{ field: "Id", rule: "hide" }, 
            { field: "Lock Version", rule: "hide" }, 
            { field: "Nwccinspection Id", rule: "hide" }, 
            { field: "Editable On Grid Id", rule: "hide" },
            { field: "Edit Percent Complete", rule: "hide" },
            { field: "Edit Comment", rule: "hide" }
          ]}
          formatRules={[{field: "loanBudgetSubCategory", action: "rename", name: "Sub Category"}, 
            {field: "tcPhoneNumber", action: "rename", name: "TC Phone Number"}
          ]}
          isGreaterThanMobile={isGreaterThanMobile}
          interiorTableData={currentInspectionDetails.length > 0 && handleInspectionDetails(currentInspectionDetails)}
          interiorTableSortable={["Category", "Line Number", "Budget Amount"]} 
          emptyStateIcon="clipboard"
          emptyStateText="Looks like there's no detail information for this inspection."
        />
      }
    ]
  ];

  const InspectionDocumentsLayout = [
    [
      {
        title: "Documents",
        size: 16,
        content: <React.Fragment>
          <BWWorkInspectionInteriorTable
            isGreaterThanMobile={isGreaterThanMobile}
            interiorTableData={currentInspectionDocumentss}
            interiorTableSortable={["Document File Name", "Created On", "Created By"]} 
            emptyStateIcon="file"
            emptyStateText="Looks like there's no document uploaded for this inspection."
          />
          <div className="inspection-upload"><BCUploadBox
            verticalClass="upload-container vertical-button"
            uploadTitle="Drag your document here or browse"
            uploadText="JPEGs, PDFs, Excel and Word Documents accepted"
            // handleUploadFiles={handleStageUpload} TODO: handler for uploading document
            uploadBoxClass="document-upload"
          /></div>
        </React.Fragment>
      }
    ]
  ];

  const completeCurrentInspectionAsync = async (inspectionId) => {
    setIsLoading(true);
    try {
      const response = FeatureFlags.IS_MOCK ? await completeMockCurrentInspection(inspectionId) : await completeCurrentInspection(inspectionId, proxyUser && proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        const completeInspection = await response.json();
        return completeInspection;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setIsLoading(false);
  };

  const downloadWorkInspectionDocumentAsync = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await downloadMockWorkInspectionDocument(currentInspectionDetails[0].nwccinspectionId) : await downloadWorkInspectionDocument(currentInspectionDetails[0].nwccinspectionId, proxyUser && proxyUser.id);
      if (response && response.ok) {
        setIsMessage(false);
        const completeDownload = await response.json();
        return completeDownload;
      }
      else {
        await handleErrorResponse(response, setIsMessage, setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }
  };

  useEffect(() => {
    const getCurrentInspectionAsync = async (projectId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockCurrentWorkInspectionInfo() : await getCurrentWorkInspectionInfo(projectId, proxyUser && proxyUser.id);
        if (response && response.ok) {
          setIsMessage(false);
          const currentInspectionInfo = await response.json();
          setCurrentInspectionInfo(deepCopy(currentInspectionInfo));
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }

      setIsLoading(false);
    };

    const getCurrentInspectionDetailsAsync = async (projectId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockCurrentWorkInspectionInfo() : await getCurrentWorkInspectionDetailInfo(projectId, proxyUser && proxyUser.id);
        if (response && response.ok) {
          setIsMessage(false);
          const currentInspectionDetails = await response.json();
          setCurrentInspectionDetails(currentInspectionDetails);
          if (currentInspectionDetails.length > 0 && currentInspectionDetails[0].nwccinspectionId) {
            await getCurrentInspectionDocumentsAsync(currentInspectionDetails[0].nwccinspectionId);
          }
          setIsLoading(false);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }

      setIsLoading(false);
    };

    const getCurrentInspectionDocumentsAsync = async (nwccinspectionId) => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockCurrentWorkInspectionInfo() : await getCurrentWorkInspectionDocuments(nwccinspectionId, proxyUser && proxyUser.id);
        if (response && response.ok) {
          setIsMessage(false);
          const inspectionDocuments = await response.json();
          setCurrentInspectionDocumentss(inspectionDocuments);
        }
        else {
          await handleErrorResponse(response, setIsMessage, setErrorResponse);
        }
      }
      catch (error) {
        handleError();
      }

      setIsLoading(false);
    };

    if (isFirstLoad) {
      getCurrentInspectionAsync(projectId);
      getCurrentInspectionDetailsAsync(projectId);
    }
  }, [user, proxyUser, setIsMessage, setErrorResponse, setIsLoading, handleError]);

  useEffect(() => {
    setIsFirstLoad(false);
  }, []);

  return (
    <div className={(isGreaterThanTablet && isSidebar) ? "landing-page hide-sidebar" : "landing-page sidebar"}>
      {isLoading ? <Loader active inline="centered" size="big" /> : <React.Fragment>
        <BCMessage
          animation={"fly down"}
          duration={750}
          visible={isMessage}
          transitionOnMount
          styles="full-width"
          onDismiss={() => setIsMessage(false)}
          errorResponse={errorResponse}
        />
        <BCConfirmationModal
          isModalOpen={isCompleteInspectModalOpen}
          setIsModalOpen={setIsCompleteInspectionModalOpen}
          modalHeader="Resend Invite?"
          modalContent="Are you sure you want to send email to selected vendor(s)?"
          handleConfirm={() => completeCurrentInspectionAsync(currentInspectionInfo.id)}
        />
        <BCTabMenuBar
          title="Work Inspection"
          menubarButton={<WorkInspectionButtonGroup />}
          subtitleLists={
            [
              [
                { title: "Inspection No", detail: `${currentInspectionInfo.inspectionNo}`},
                { title: "Loan Property", detail: `${currentInspectionInfo.loanPropertyName}`},
                { title: "Loan Draw", detail: `${currentInspectionInfo.loanDrawName}`},
                { title: "Submitted On", detail: `${convertToDateString(currentInspectionInfo.submittedOn)}`}
              ],
              [
                { title: "TC Info", detail: `${currentInspectionInfo.transactionCoordinatorName}`},
                { title: "Project", detail: `${currentInspectionInfo.project}`},
                { title: "Document", detail: <Link className="inspection-detail-link" onClick={() => downloadWorkInspectionDocumentAsync()} >{currentInspectionInfo.documentFileName}</Link>}
              ],
              [
                { title: "Requested Date", detail: `${convertToDateString(currentInspectionInfo.requestedDate)}`},
                { 
                  title: "Schedule Date", 
                  detail: handleDateChangeInputField(currentInspectionInfo.scheduledDate, "scheduledDate"),
                  listItemClass: "tab-menubar-subtitle-calendar-input"
                },
                { 
                  title: "Inspected On", 
                  detail: handleDateChangeInputField(currentInspectionInfo.dateInspected, "dateInspected"),
                  listItemClass: "tab-menubar-subtitle-calendar-input"
                }
              ],
              [
                { title: "Note", 
                  detail: <BCFormInput 
                    type="textarea"
                    placeholder="Write your note here..."
                    obj={currentInspectionInfo}
                    value={currentInspectionInfo && currentInspectionInfo.note ? currentInspectionInfo.note : ""}
                    field="note"
                    handleFormChange={() => setCurrentInspectionInfo({...currentInspectionInfo})}
                  />,
                  listItemClass: "tab-menubar-subtitle-textarea"
                }
              ]
            ]
          }
          tabs={Object.values(BorrowerConstants.currentInspectionInteriorCardTabs)}
          activeTab={activeTab}
          setActiveTab={handleActiveTabAsync}
          isGreaterThanMobile={isGreaterThanMobile}
        />
        <BCDashboard
          DashboardLayout={isInteriorCardLoading ? LoaderLayout : 
            activeTab === BorrowerConstants.currentInspectionInteriorCardTabs.Details.name.toLocaleUpperCase() ? InspectionDetailsLayout :
            activeTab === BorrowerConstants.currentInspectionInteriorCardTabs.Documents.name.toLocaleUpperCase() ? InspectionDocumentsLayout : []}
          isGreaterThanMobile={isGreaterThanMobile}
        />
        {FeatureFlags.IS_DEBUG && <React.Fragment>
          <button onClick={() => console.log(currentInspectionInfo)}>currentInspectionInfo</button>
          <button onClick={() => console.log(currentInspectionDetails)}>currentInspectionDetails</button>
          <button onClick={() => console.log(updatedInspectionDetailList)}>updatedInspectionDetailList</button>
        </React.Fragment>}
      </React.Fragment>
      }
    </div>
  );
};

export default BWCurrentWorkInspection;